var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"mb2",class:_vm.rowClass},[_c('el-col',{staticClass:"text-right",attrs:{"span":_vm.span}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.label),expression:"label"}],staticStyle:{"padding-right":"10px"}},[_vm._v(_vm._s(_vm.label)+":")])]),_c('el-col',{attrs:{"span":24-_vm.span}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }